import { Component } from '@angular/core';
import { LoaderService } from "../core/services/loader.service";
import { Observable } from "rxjs";
import { SplashScreen } from '@capacitor/splash-screen';
import { SafeArea } from 'capacitor-plugin-safe-area';
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent {
  loading$: Observable<boolean>;
  isPublicLanding: boolean = false;

  constructor(private loaderService: LoaderService, private router: Router) {
    this.loading$ = this.loaderService.updateLoader$;
    this.isPublicLanding = this.isPublicLandingUrl(this.router.url);
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.isPublicLanding = this.isPublicLandingUrl(e.urlAfterRedirects);
      });
    this.splashScreenHandler().then(()=>{});
  }
  /**
   * The routes we treat as "public landing" — Diwali campaign pages that render edge-to-edge
   * and must NOT inherit the app's standard header/footer.
   */
  private isPublicLandingUrl(url: string): boolean {
    return url.startsWith('/festive-login')
      || url.startsWith('/festive-social-media-offer')
      || url.startsWith('/festive-store-offer')
      || url.startsWith('/spin');
  }

  async adjustLayout(){
      const {insets}=await SafeArea.getSafeAreaInsets();
      document.documentElement.style.setProperty('--safe-top',`${insets.top}px`);
  }
  async splashScreenHandler() {
    await this.adjustLayout();
    await SplashScreen.show({
      showDuration: 3000,
      autoHide: true
    });

    setTimeout(async () => {
      await SplashScreen.hide();
    }, 3000);
  }
}
